const EnergyLinkErrorPage = () => {
  return (
    <div>
      <h3>Access Denied</h3>
      <p>
        You do not have permission to access Energy Link. Please contact your
        administrator for assistance.
      </p>
    </div>
  );
};

export { EnergyLinkErrorPage };
